import React, {useEffect} from 'react';
import './App.css';
import Header from "../shared/Header/Header";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {CalculoVET, GeradorRotulos, HandleLogin, Home} from "../pages";
import {useDispatch} from "react-redux";
import {loggedIn} from "../../store/ducks/auth";

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const cachedAuthToken = localStorage.getItem("auth.token");
    if (!cachedAuthToken) {
      // has no stored stuff
      return;
    }

    dispatch(loggedIn(cachedAuthToken));
  }, [dispatch])

  return (
    <BrowserRouter>
      <Header/>
      <Switch>
        <Route path="/calculoVET"><CalculoVET/></Route>
        <Route path="/geradorRotulos"><GeradorRotulos/></Route>
        <Route path="/loginSucceeded"><HandleLogin/></Route>
        <Route path="/"><Home/></Route>
      </Switch>
      <div className="trademark">
        <a href="https://luizloyola.com.br" target="_blank" rel="noopener noreferrer" className="link text-dark text-decoration-none">© Luiz Loyola Desenvolvimento, 2021</a>
      </div>
    </BrowserRouter>
  );
}

export default App;
